import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext.tsx'

const RecetaRegistroApp = lazy(() => import('./view/RecetasRegistro'))
const RecetasActualizarApp = lazy(() => import('./view/RecetasActualizar'))
const RecetaGestion = lazy(() => import('./view/RecetasGestion'))

export const recetasRoutesMap = {
  gestion: {
    path: '/recetas/gestion',
    name: 'Receta de producción',
    action: 'RECETAS',
  },
  registro: {
    path: '/recetas/registro',
    name: 'Nueva receta',
    action: 'ADMINISTRAR_RECETAS',
  },
  actualizar: {
    path: '/recetas/actualizar/:id',
    name: 'Actualizar receta',
    action: 'ADMINISTRAR_RECETAS',
  },
}

const recetasRoutes = [
  {
    path: recetasRoutesMap.gestion.path,
    element: (
      <OperacionesProvider>
        <RecetaGestion />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: recetasRoutesMap.registro.path,
    element: (
      <OperacionesProvider>
        <RecetaRegistroApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: recetasRoutesMap.actualizar.path,
    element: (
      <OperacionesProvider>
        <RecetasActualizarApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
]
export default recetasRoutes
